import React from "react";
import Icon from "@mdi/react";
import { mdiMagnify } from "@mdi/js";
import "../../assets/styles/components/textfield.scss";

interface Props {
  placeholder?: string;
  color?: string;
  className?: string;
  option?: {
    value: string;
    name: string;
  }[];
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeOtherd: (index: string) => any;
}

const SearchFieldSelect: React.FC<Props> = ({
  placeholder,
  onChange,
  color = "#f4f4f4",
  className = "",
  option = [],
  onChangeOtherd,
}) => {
  const setOther = (e: string) => {
    onChangeOtherd(e);
  };
  return (
    <div
      className={`search-field ${className}`}
      style={{ backgroundColor: color }}
    >
      <select
        id="select"
        className="col-2 search-field-slect"
        onChange={(e) => {
          setOther(e.target.value);
        }}
      >
        {option.map((option, index) => (
          <option value={option.value} key={index}>
            {option.name}
          </option>
        ))}
      </select>
      <input type="text" placeholder={placeholder} onChange={onChange} />
      <span>
        <Icon path={mdiMagnify} size="30" color="#5BAEA9" />
      </span>
    </div>
  );
};

export default SearchFieldSelect;
